import React from 'react';
import { SalesPage } from './components/SalesPage';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <>
      <SalesPage data-id="element-0" />
      <PurchasePopup data-id="element-1" />
    </>;
}